module.exports = __webpack_public_path__ + "img/privacy.7f526cb4.jpg";